<template>
    <div>
        <!-- <v-container class="pa-4" style="height: 100vh;">
            <div>
                <v-row>
                    <v-col cols="6">
                        <v-btn
                            color="rgb(195 194 194)"
                            dark
                            rounded
                            elevation="0"
                        >
                            <v-icon
                            dark
                            left
                            >
                            mdi-arrow-left
                            </v-icon>Back
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-container> -->
        <v-main style="height: auto;">
            <v-container class="pa-0" v-model="openDialogUpload" fullscreen>
                <div>
                <v-card-title class="sticky-top-title" style="justify-content: space-between;"><div>อัปโหลดใบเสร็จ</div><div @click="$router.push('/UploadPaymentForPoint')"><v-icon color="red">mdi-close-circle</v-icon>ปิด</div></v-card-title>
                <v-card-text style="background-color: rgb(255, 255, 255);" class="px-7 pt-1">
                    <v-form ref="form" v-model="validAdd" lazy-validation>
                        <div v-for="(item, index) in dataFormAdd" :key="index">
                            <div style="display: flex;justify-content: space-between;">
                                <p class="mb-2">รายการที่ {{ index + 1 }}.</p>
                                <p class="mb-2" style="background-color: #fa6b6b;border-radius: 10px;color: white;padding-left: 15px;padding-right: 15px;" v-if="item.img_slip !== ''" @click="item.img_slip = ''">ลบรูป</p>
                                <p class="mb-2" style="background-color: #fa6b6b;border-radius: 10px;color: white;padding-left: 15px;padding-right: 15px;" v-if="item.img_slip === '' && index !== 0" @click="removeList(index)">ลบรายการ</p>
                            </div>
                            <div>
                                <v-card
                                  @click="chooseImage(index, item)"
                                  elevation="0"
                                  class="image-input"
                                  :style="{
                                    'background-size': 'contain',
                                    'background-position': 'center center',
                                    'background-repeat': 'no-repeat',
                                    'padding-top': '10px',
                                    'display': 'flex',
                                    'align-items': 'center'
                                  }"
                                >
                                      <span
                                    v-if="item.img_slip === ''"
                                    class="placeholder"
                                    style="height: 100px;justify-content: center;align-items: center;padding-top: 10px;"
                                  >
                                    <div v-if="item.img_slip === ''">
                                        <v-icon size="54" color="primary">mdi-file</v-icon>
                                        <div>กดเพื่อเลือกรูปใบเสร็จ</div>
                                    </div>
                                  </span>
                                  <span
                                    v-if="item.img_slip !== ''"
                                    class="placeholder"
                                    style="height: 100px;justify-content: center;align-items: center;"
                                  >
                                    <v-icon size="54" color="#52c452">mdi-file-check</v-icon>
                                    <div>กดเพื่อดูรูป</div>
                                  </span>
                                </v-card>
                            </div>
                            <div>
                                <div style="display: flex;" >
                                    <v-file-input
                                        :id="`my-link${index}`"
                                        label="File input"
                                        type="file"
                                        ref="fileInput"
                                        accept="image/*"
                                        class="mt-3"
                                        :rules="[rules.required]"
                                        @change="updatePictureUrl"
                                        style="display: none;"
                                    ></v-file-input>
                                    <!-- <p v-if="item.img_slip">{{ item.img_slip.name }}</p> -->
                                    <p class="mb-1 mt-1" style="color:red" v-if="!item.img_slip">กรุณาใส่รูปใบเสร็จ</p>
                                </div>
                                <p>หมายเหตุ :
                              กรุณาใส่รูปใบเสร็จ โดยใบเสร็จจะต้องเห็นรายละเอียดชัดเจน
                              ได้แก่ ชื่อร้านค้า, วันที่เข้าใช้บริการ, จำนวนเงิน เป็นต้น</p>
                            </div>
                            <p class="mb-0 mt-3">กรุณาเลือกร้านที่เข้าบริการ</p>
                            <v-autocomplete
                            v-model="dataFormAdd[index].exchangrateId"
                            dense
                            :rules="[rules.required]"
                            :items="productExchange"
                            item-text="name"
                            item-value="productExchangeRateId"
                            rounded
                            attach
                            placeholder="ร้านที่เข้าบริการ"
                            solo
                            ></v-autocomplete>
                        </div>
                    </v-form>
                        <div class="pb-4">
                            <v-btn class="mb-3" color="primary"  @click="addSlip"  block rounded><v-icon class="mr-1">mdi-file-plus</v-icon>เพิ่มใบเสร็จ</v-btn>
                            <v-btn @click="uploadPayment" :loading="loadingUpload" :disabled="!validAdd || checkImg()" style="color: white;" rounded block color="green">
                             <v-icon>mdi-content-save</v-icon> ส่งรายการใบเสร็จ
                            </v-btn>
                        </div>
                </v-card-text>
                <v-divider class="mt-0 mb-0"></v-divider>
                <!-- <v-card-actions class="sticky-bottom-actions" @click="uploadPayment">
                    <div color="green" dark block>
                        <v-icon color="white" class="mr-2">mdi-content-save</v-icon>ส่งรายการใบเสร็จ
                    </div>
                </v-card-actions> -->
            </div>
            </v-container>
            <v-dialog v-model="showPayment" fullscreen>
                <v-card>
                    <v-card-title style="justify-content: flex-end;color: red;" @click="showPayment = false"><v-icon color="red">mdi-close-circle</v-icon>ปิด</v-card-title>
                    <v-card-text>
                        <v-img :src="paymentShow"></v-img>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="showPayment2" fullscreen>
                <v-card>
                    <v-card-title style="justify-content: flex-end;color: red;" @click="showPayment2 = false"><v-icon color="red">mdi-close-circle</v-icon>ปิด</v-card-title>
                    <v-card-text>
                        <v-img :src="paymentShow2"></v-img>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-main>
    </div>
  </template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Swal from 'sweetalert2'
// import Swal from 'sweetalert2'
import axios from 'axios'
export default {
  name: 'PointCollect',
  data () {
    return {
      showPayment2: false,
      paymentShow2: null,
      loadingUpload: false,
      pic: [],
      loading: true,
      success: false,
      levelup: false,
      failed: false,
      token: null,
      validAdd: true,
      point: null,
      message: null,
      level: null,
      member: null,
      levelUpdate: null,
      openDialogUpload: false,
      index: null,
      profile: [],
      dataPayment: null,
      filesAdd: null,
      dataFormAdd: [],
      paymentShow: null,
      showPayment: false,
      productExchange: null,
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          `${this.$t('message.fillNum')}`,
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          `${this.$t('message.fillNum')}`,
        required: value => !!value || 'กรุณากรอกข้อมูล.',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  computed: {
    newData () {
      return this.GET_MEMBERINFO()
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.dataFormAdd.push({
      'lineUserId': this.newData.lineUserId,
      'name': this.newData.nameCustomer,
      'tel': this.newData.tel,
      'img_slip': '',
      'status': 'waiting',
      'exchangrateId': null,
      'shopId': this.newData.shopId
    })
    this.getDataPayment()
    this.getExchange()
  },
  methods: {
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async getDataPayment () {
      this.dataPayment = await this.callBeTaskAPI('get', `/AddCoin/get?lineUserId=${this.newData.lineUserId}&shopId=${this.newData.shopId}`)
    },
    async getExchange () {
      this.productExchange = await this.callBeTaskAPI('get', `/productExchangeRate/get?shopId=${this.newData.shopId}`)
    },
    async collectPoint () {
    },
    checkImg () {
      return this.dataFormAdd.some(item => item.img_slip === '' || item.img_slip === null)
    },
    chooseImage (index, item) {
      if (item.img_slip !== '') {
        this.showPayment = true
        this.paymentShow = URL.createObjectURL(
          item.img_slip
        )
      } else {
        this.index = index
        var link = document.getElementById(`my-link${index}`)
        link.click()
      }
    },
    onSelectFile () {
      const input = this.$refs.fileInput
      this.filesAdd = input.files
      if (this.filesAdd && file.type.startsWith('image/')) {
        this.img_slip = URL.createObjectURL(this.filesAdd[0])
      } else {
        this.img_slip = ''
      }
      // alert('ssss')
    },
    addSlip () {
      this.pic.push('')
      this.dataFormAdd.push({
        lineUserId: this.newData.lineUserId,
        name: this.newData.nameCustomer,
        tel: this.newData.tel,
        img_slip: '',
        status: 'waiting',
        exchangrateId: null,
        shopId: this.newData.shopId
      })
      window.scrollTo({
        top: document.body.scrollHeight, // Adjust the position you want to scroll to
        behavior: 'smooth'
      })
      //   window.scrollTo({
      //     top: 400, // Adjust the position you want to scroll to
      //     behavior: 'smooth'
      //   })
    },
    updatePictureUrl (event) {
      const file = event
      if (file.type.startsWith('image/')) {
        this.dataFormAdd[this.index].img_slip = file
      } else {
        Swal.fire({
          title: 'รองรับเฉพาะไฟล์รูปภาพเท่านั้น',
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'รับทราบ'
        })
      }
    //   console.log('this.dataFormAdd[this.index].img_slip', this.dataFormAdd[this.index].img_slip)
    },
    async uploadPayment () {
      let a = this.$refs.form.validate()
      if (a === true) {
        this.loadingUpload = true
        await this.uploadPicture()
        // setTimeout(async () => {

        // }, 2000)
        // const result = await this.callBeTaskAPI('post', `/AddCoin/add`, this.dataFormAdd)
        // if (result) {
        //   if (result.status === true) {
        //     this.success = true
        //   } else if (result.status === false) {
        //     this.success = false
        //   }
        // }
        // console.log('result', result)
        // this.loadingUpload = false
        // console.log('success', this.dataFormAdd)
        // this.clearDataupload()
      } else {
      }
    },
    colorStatus (item) {
      if (item === 'waiting') {
        return '#1976d2'
      } else if (item === 'comfirm') {
        return '#48a55b'
      } else {
        return 'red'
      }
    },
    clearDataupload () {
      this.openDialogUpload = false
      this.pic = []
      this.dataFormAdd = [{
        'lineUserId': this.newData.lineUserId,
        'name': this.newData.nameCustomer,
        'tel': this.newData.tel,
        'img_slip': '',
        'status': 'waiting',
        'exchangrateId': null,
        'shopId': this.newData.shopId
      }]
      this.$refs.form.resetValidation()
    },
    removeList (index) {
      this.dataFormAdd.splice(index, 1)
    },
    async uploadPicture () {
      // Create an array to store promises
      const promises = this.dataFormAdd.map(async (item) => {
        if (item.img_slip) {
          let params = new FormData()
          params.append('file', item.img_slip)
          const response = await axios.post(this.DNS_IP + `/file/upload/marketPayment`, params)
          item.img_slip = response.data
        }
      })

      // Wait for all promises to resolve
      await Promise.all(promises)

      // Now call the insertData function
      await this.insertData()
    },
    async insertData () {
      await this.callBeTaskAPI('post', `/AddCoin/add`, this.dataFormAdd)
      this.loadingUpload = false
      Swal.fire({
        title: 'สำเร็จ',
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ตกลง'
      }).then((confirm) => {
        if (confirm.isConfirmed) {
          this.clearDataupload()
          this.getDataPayment()
          this.$router.push('/UploadPaymentForPoint')
        }
      })
    }
  }
}
</script>
<style scoped>
.sticky-top-title {
  position: sticky;
  top: 0;
  border-bottom: solid #a0a0a0 1px;
  background-color: white; /* Adjust as needed */
  z-index: 1; /* Ensure it's above the content */
}

.sticky-bottom-actions {
  position: sticky;
  bottom: 0;
  background-color: rgb(70, 162, 60); /* Adjust as needed */
  z-index: 1; /* Ensure it's above the content */
  display: flex;
  justify-content: center;
  color: white;
  height: 80px;
}
.image-input {
  text-align: center !important;
  cursor: pointer !important;
  background-size: cover !important;
  background-position: center center !important;
  border: dashed #d1d1d1 !important;
    border-radius: 10px !important;
    height: 150px !important;
    justify-content: center !important;
}
.image-input2 {
    display: block;
  text-align: center;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
  border: dashed #d1d1d1;
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Point/selectPayment.vue